export { default as PickTicketNewFlowDetailList } from './PickTicketNewFlowDetailList';
